// extracted by mini-css-extract-plugin
export default {"banner":"offlineBanner_banner__VD9mH","icon":"offlineBanner_icon__Tzc2g","text":"offlineBanner_text__UhVqO"};